import { AnyAppEvent, AppEvent } from "../../appEvent.types";
import { z } from "zod";

const eventName = "open-exponent-profile" as const;

export const OpenExponentProfileEventDataSchema = z.object({
  structureId: z.string(),
  eventId: z.string(),
});

export type OpenExponentProfileEventData = z.infer<
  typeof OpenExponentProfileEventDataSchema
>;

export type OpenExponentProfileEvent = AppEvent<
  typeof eventName,
  OpenExponentProfileEventData
>;

export const isOpenExponentProfileEvent = (
  event: AnyAppEvent
): event is OpenExponentProfileEvent => event.name === eventName;

export { eventName as openExponentProfile };
